import { useEffect, useState } from "react";
import { useNavigate, useParams, useSearchParams } from "react-router-dom";
import StripeScreen from "./StripeScreen";
import RedsysScreen from "./RedsysScreen";
import TpvWaitScreen from "./TpvWaitScreen";
import { getTipById } from "../api/tip";
import { isTipPaid, leavePaidTipPayment } from "../utils/tipPaymentStatus";
import logo from "../assets/logo.png";
import "./StripeScreen.css";

function PayoutScreen() {
  const { id: businessId, idtip: tipId } = useParams();
  const [searchParams] = useSearchParams();
  const method = searchParams.get("method");
  const navigate = useNavigate();
  const [allowed, setAllowed] = useState(false);

  useEffect(() => {
    let cancelled = false;

    const checkTip = async () => {
      try {
        const tipRes = await getTipById(tipId);
        if (isTipPaid(tipRes?.data?.estadoPago)) {
          leavePaidTipPayment(navigate, businessId);
          return;
        }
      } catch (error) {
        console.error("Error comprobando estado de la propina:", error);
      }

      if (!cancelled) setAllowed(true);
    };

    checkTip();

    return () => {
      cancelled = true;
    };
  }, [tipId, businessId, navigate]);

  if (!allowed) {
    return (
      <div className="loading-container">
        <img
          src={logo}
          alt="Tipify Logo"
          className="loading-logo pulse-effect"
        />
      </div>
    );
  }

  if (method === "tpv") return <TpvWaitScreen />;
  if (method === "stripe") return <StripeScreen />;
  return <RedsysScreen />;
}

export default PayoutScreen;
